// https://github.com/auth0/jwt-decode
import jwtDecode from 'jwt-decode';
export default class Jwt {
    // Initialize and Assign `jwt` property upon initialize
    constructor(jwt) {
        this.jwt = jwt;
        this.current = parseInt((Date.now() / 1000).toFixed(0), 10);
    }
    isNotExpired() {
        let decodedJWT;
        try {
            decodedJWT = jwtDecode(this.jwt);
        }
        catch (e) {
            // Handle falsey decode of jwt
            return false;
        }
        // token is not expired if .exp is not undefined and .exp is greater than or equal current
        // false everything else false to this measure?
        return decodedJWT.exp !== undefined && decodedJWT.exp >= this.current;
    }
    isValidJwtCreated() {
        let decodedJWT;
        try {
            decodedJWT = jwtDecode(this.jwt);
        }
        catch (e) {
            // Handle falsey decode of jwt
            return false;
        }
        // Get unix timestamp in rails console using `Time.zone.now.getutc.to_i`
        // since CMS EC2 instance is in UTC timezone
        // Add allowance or extra time since while deploying some user may login
        // and their jwt created time is in between the deployment
        // you can deploy the changes at midnight or past midnight
        // Change the unix timestamp before deploying to prod
        return decodedJWT.created !== undefined && decodedJWT.created >= 1715337304;
    }
}
